import React from "react";
import arrowRight from "../../../assets/images/arrow-right-colored.svg";

interface ViewMoreProps {
  onclick: () => void;
}

const ViewMoreButton: React.FC<ViewMoreProps> = ({ onclick }) => {
  return (
    <button
      className="flex overflow-hidden gap-2 justify-center items-center self-center px-4 py-2 mt-6 text-base font-medium tracking-normal leading-loose text-center text-indigo-600 rounded-xl border border-indigo-600 border-solid"
      onClick={onclick}
    >
      <span className="self-stretch my-auto">View more</span>
      <img
        loading="lazy"
        src={arrowRight}
        className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
        alt=""
      />
    </button>
  );
};

export default ViewMoreButton;
